import api from '../api/api-list'
import { AllModule } from '@/assets/json/cv'
import Cookies from 'js-cookie'
import { moduleMixin } from '../assets/js/mixin/cv'

const state = {
	cv: {}, // cv的数据
	hasProfile: false, // 是否有基本信息
	cvSort: [], // 简历的排序
	score: 0, //简历分数
	suggestions: {}, // 简历建议
	suggestTime: '',
	suggestInfo: {}, // 当前所修改建议的 title  advice  description
	overageModule: [], // 其他模块
	onlineCvValid: {}, // 在线简历校验数据
	onlineCvBasic: {}, // 在线简历基本信息
	onlineContact: '', // 在线简历手机号
	onlineCvData: {}, // 在线简历数据
	onlineVisibility: false, // 在线简历私密度
	profiles: {}, // 基本信息
	works: [], // 工作
	orgs: [], // 活动
	edus: [], // 教育经历
	personal_summary: [], // 个人总结
	project_experience: [], // 项目经历
	reasearch_experience: [], // 研究经历
	honor: [], // 荣誉
	skill_list: [], // 技能
	custom: [], // 自定义
	extra: {}, // 其他
	currentInfoTitle: '', // 当前经历的title
	moduleData: [], // 整合cv的数据
	currentInfo: {}, // 当前编辑的经历
	examples: [],
	example_tags: [],
	example_options: [],
	verbs: [],
	faqs: [],
	refreshEditor: false,
	section_titles: '',
	syncSuccess: false, // 是否同步了在线简历
	isFirstCvInfo: {
		isFirst: false,
		data: {}
	},
	npsFlag: false,
	cvIntentionData: {
		current_job: '',
		expected_salary: '',
		exp_job: '',
		exp_city: '',
		city_id: '',
		profession_id: ''
  },
	isSubItemInfoIds: ""
}

const getters = {
	eduFullInfo: state => state.edus,
	workFullInfo: state => state.works,
}

const actions = {
	// 获取默认模块标题
	getCvSectionTitle: async function({ commit, dispatch }) {
		try {
			let res = await api.cv.getCvSectionTitle()
			if (res.code === 1000) {
				commit('setCvSectionTitle', res.data)
			}
		} catch (err) {
			console.error(err)
		}
	},
	// 获取简历详情数据
	getCvDetail: async function ({ commit, dispatch }, { token, share }) {
		try {
			let res = {}
			if (share) {
				res = await api.cv.getCvDetailByShare(token)
			} else {
				res = await api.cv.getCvDetail(token)
			}
			if (res.code === 1000) {
				const baseFields = [ 'works', 'orgs', 'edus', 'opus' ]
				let { basic_info } = res.data
				let submodule_info = res.data.submodule_info;
				let sort = submodule_info.sections_position

				const cvSort = submodule_info.sections_position.map(item => item.type)
				const overageModule = AllModule.filter(i => !cvSort.includes(i.type))
				if (basic_info.kind === 'template' || basic_info.kind === 'sample') {
					basic_info.created_at = null
					basic_info.updated_at = null
				}
				sort.forEach(item => {
					if (baseFields.includes(item.type)) {
						item.title = submodule_info[`${ item.type }_title`] || item.title
					} else {
						item.title = submodule_info.custom_sections_titles[`${ item.id }_title`] || item.title
					}
				})
				commit('changeCvDetail', res.data)
				commit('changeCvSort', sort)
				commit('changeOverageModule', overageModule)
				dispatch('updateFont')
			} else if ((res.code === 80120 || res.code === 80121) && !share) {
				localStorage.setItem('loginErr', true)
				window.location.href = `/cvs`
			}
			return res
		} catch (e) {
			console.log(e)
		}
	},
	updateFont ({ state, dispatch }) {
		const { format_info, basic_info: { lang, kind, token }, format_info: { font } } = state.cv
		const fontList = [ 'font-1', 'font-2', 'font-3' ]
		if (!kind && lang === 'en' && fontList.includes(font)) {
			const payload = {
				operation_type: 'update_format_info',
				format_info: {
					font: 'font-4'
				}
			}
			dispatch('updateCvDetail', { token, payload })
		}
	},
	// 更新简历详情数据
	updateCvDetail: async function ({ commit, state }, { token, payload }) {
		try {
			let res = await api.cv.updateCvDetail(token, payload)
			if (res.code === 1000) {
				let cv = { ...state.cv, ...res.data }
				commit('changeCvDetail', cv)
			}
			return res
		} catch (e) {
			console.log(e)
		}
	},
	// 更新简历详情数据
	updateVipCvDetail: async function ({ commit, state }, { token, payload }) {
		try {
			let res = await api.cv.updateVipCvDetail(token, payload)
			if (res.code === 1000) {
				let cv = { ...state.cv, ...payload }
				commit('changeCvDetail', cv)
			}
			return res
		} catch (e) {
			console.log(e)
		}
	},
	// 创建简历
	createCvDetail: async function ({ commit }, payload) {
		let res = await api.cv.createCvDetail(payload)
		if (res.code === 1000) {
			commit('changeCvDetail', res.data)
		}
		return res
	},
	// 检查分数
	cvCheck: async function ({ commit }, payload) {
		try {
			let res = await api.cv.cvCheck(payload)
			if (res.code === 1000) {
				commit('changeSuggest', res.data)
				commit('setSyncData', res.data.sync_is_success)
			}
		} catch (error) {
			console.log(error)
		}
	},
	// 自动排序
	cvAutoSort: async function ({ commit, state }, save) {
		try {
			let cvData = {
				cv: state.cv,
				save
			}
			let { submodule_info: { sections_position }, basic_info: { token } } = state.cv
			sections_position.forEach(item => {
				if (item.type === 'custom') {
					cvData[item.id] = state[item.id]
				} else if (item.type === 'extras') {
					cvData.extras = state.extra
				} else {
					cvData[item.type] = state[item.type]
				}
			})
			let res = await api.cv.autoSort(token, cvData)
			if (res.code === 1000) {
				let { data } = res
				for (let key in data) {
					if (key === 'extras') commit('changeExtra', data.extras)
					else if (key === 'cv') commit('changeCvDetail', data.cv)
					else if (key !== 'save') commit('changeModuleInfoBySort', { moduleName: key, infos: data[key] })
				}
				commit('changeRefreshEditor', true)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 创建基本信息
	createProfileData: async function ({ commit }, { token, payload }) {
		try {
			let res = await api.cv.createProfileData(token, payload)
			if (res.code === 1000) {
				commit('changeProfileData', res.data.profile)
				return res.code
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 更新基本信息
	updateProfileData: async function ({ commit }, { token, payload }) {
		try {
			let res = await api.cv.updateProfileData(token, payload)
			if (res.code === 1000) {
				commit('changeProfileData', res.data.profile)
				return res.code
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 更新基本信息
	updateVipProfileData: async function ({ commit }, { token, payload, profile }) {
		try {
			let res = await api.cv.updateVipProfileData(token, payload)
			if (res.code === 1000) {
				// commit('changeProfileData', res.data.profile)
				commit('changeProfileData', profile)
			}
			return res.code
		} catch (e) {
			console.log(e)
		}
	},

	// 获取基本信息数据
	getProfileData: async function ({ commit, state }, payload = {}) {
		try {
			let { basic_info: { token } } = state.cv
			let res = {}
			if (payload.share && payload.shareToken) {
				res = await api.cv.getProfileDataByShare(payload.shareToken)
			} else {
				res = await api.cv.getProfileData(token)
			}
			if (res.code === 1000) {
				commit('changeProfileData', res.data.profile)
				commit('changeProfileState', true)
			} else {
				commit('changeProfileData', {})
				return res.code
			}
		} catch (error) {
			console.log(error)
		}
	},
	// 获取模块的信息
	getModuleInfo: async function ({ commit }, { payload, moduleName, share }) {
		try {
			let apiMethod = ''
			if (share) {
				if(moduleName === 'edus'){
					apiMethod = 'getEduInfoByShare'
				}else if(moduleName === 'orgs'){
					apiMethod = 'getOrgInfoByShare'
				}else if(moduleName === 'opus'){
					apiMethod = 'getOpuInfoByShare'
				}else {
					apiMethod = 'getWorkInfoByShare'
				}
				// apiMethod = moduleName === 'edus' ? 'getEduInfoByShare' : moduleName === 'orgs' ? 'getOrgInfoByShare' : 'getWorkInfoByShare'
			} else {
				if(moduleName === 'edus'){
					apiMethod = 'getEduExperience'
				}else if(moduleName === 'orgs'){
					apiMethod = 'getOrgExperience'
				}else if(moduleName === 'opus'){
					apiMethod = 'getOpuExperience'
				}else {
					apiMethod = 'getWorkExperience'
				}
				// apiMethod = moduleName === 'edus' ? 'getEduExperience' : moduleName === 'orgs' ? 'getOrgExperience' : 'getWorkExperience'
			}
			let res = await api.cv[apiMethod](payload)
			if (res.code === 1000) {
				commit('changeModuleInfo', { moduleName, info: res.data[moduleName] })
			} else {
				// localStorage.setItem('loginErr', true)
				// window.location.href = '/cvs'
			}
		} catch (error) {
			console.log(error)
		}
	},
	updateModuleInfo: async function ({ commit }, { id, payload, moduleName }) {
		try {
			let apiMethod = '';
			if (moduleName === 'works') {
				apiMethod = 'updateWorkExperience'
			} else if (moduleName === 'orgs') {
				apiMethod = 'updateOrgExperience'
			} else if (moduleName === 'opus') {
				apiMethod = 'updateOpuExperience'
			} else {
				apiMethod = 'updateEduExperience'
			}
			// const apiMethod = moduleName === 'works' ? 'updateWorkExperience' : moduleName === 'orgs' ? 'updateOrgExperience' : 'updateEduExperience'
			let res = await api.cv[apiMethod](id, payload)
			return res.code
		} catch (e) {
			console.log(e)
		}
	},
	// 创建模块信息
	createModuleInfo: async function ({ commit }, { payload, type }) {
		try {
			let apiMethod = ''
			if (type === 'works') {
				apiMethod = 'createWorkExperience'
			} else if (type === 'orgs') {
				apiMethod = 'createOrgExperience'
			} else if (type === 'opus') {
				apiMethod = 'createOpuExperience'
			} else {
				apiMethod = 'createEduExperience'
			}
			// const apiMethod = type === 'works' ? 'createWorkExperience' : type === 'orgs' ? 'createOrgExperience' : 'createEduExperience'
			let res = await api.cv[apiMethod](payload)
			if (res.code === 1000) {
				return res.data
			} else {
				return res.code
			}
		} catch (error) {
			console.log(error)
		}
	},
	// 通过id获取自定义模块的内容
	getCustomInfoByIds: async function ({ commit }, { id, payload, moduleName, share }) {
		try {
			let res = {}
			if (share) {
				res = await api.cv.getCustomInfoByShare(id, payload)
			} else {
				res = await api.cv.getCustomInfoByIds(id, payload)
			}
			if (res.code === 1000) {
				commit('changeModuleInfo', { moduleName, info: res.data.infos })
			} else {
				// localStorage.setItem('loginErr', true)
				// window.location.href = '/cvs'
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 创建自定义模块
	createCustom: async function ({ commit }, payload) {
		try {
			let res = await api.cv.createCustom(payload)
			if (res.code === 1000) {
				return res.data.custom_section
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 创建自定义模块info
	createCustomInfo: async function ({ commit }, { id, payload }) {
		try {
			let res = await api.cv.createCustomInfo(id, payload)
			if (res.code === 1000) {
				return res.data.info
			} else {
				return res.code
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 更新自定义模块的info
	updateCustomInfo: async function ({ commit }, { customId, infoId, payload }) {
		try {
			let res = await api.cv.updateCustomInfo(customId, infoId, payload)
			return res.data.info
		} catch (e) {
			console.log(e)
		}
	},
	// 删除自定义模块info
	deleteCustomInfo: async function ({ commit }, { customId, infoId, moduleName }) {
		try {
			let res = await api.cv.deleteCustomInfo(customId, infoId)
			console.log(res, '删除自定义模块info')
		} catch (e) {
			console.log(e)
		}
	},
	// 删除自定义模块
	deleteCustom: async function ({ commit }, { customId, moduleName }) {
		try {
			let res = await api.cv.deleteCustom(customId)
			console.log(res, '删除自定义模块')
			// return await api.cv.deleteSection(payload)
		} catch (e) {
			console.log(e)
		}
	},
	// 获取其他/技能模块的信息
	getExtraInfo: async function ({ commit }, { payload, share }) {
		try {
			let res = {}
			if (share) {
				res = await api.cv.getExtrasInfoByShare(payload)
			} else {
				res = await api.cv.getExtraInfo(payload)
			}
			if (res.code === 1000) {
				commit('changeExtra', res.data.others)
			}
		} catch (error) {
			console.log(error)
		}
	},
	// 创建其他/技能模块
	createExtra: async function ({ commit, state }, payload) {
		try {
			let res = await api.cv.createExtra(payload)
			let infos = JSON.parse(JSON.stringify(state.extra))
			if (res.code === 1000) {
				for (let key in res.data.others) {
					if (res.data.others[key].id) infos[key] = res.data.others[key]
				}
				commit('changeExtra', infos)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 更新模块
	updateExtra: async function ({ commit, state }, payload) {
		try {
			let res = await api.cv.updateExtra(payload)
			let infos = JSON.parse(JSON.stringify(state.extra))
			if (res.code === 1000) {
				for (let key in res.data.others) {
					if (res.data.others[key].id) infos[key] = res.data.others[key]
				}
				commit('changeExtra', infos)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 获取案例，动词，小贴士
	getAssistInfo: async function ({ commit, state }, { payload, type }) {
		try {
			let { basic_info: { lang } } = state.cv
			if (type === 'examples') payload.lang = lang
			let res = await api.cv.getAssistInfo(payload)
			if (res.code === 1000) {
				commit('changeAssistInfo', { type, info: res.data })
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 校验在线简历是否完整
	checkCvValid: async function ({ commit }, token) {
		try {
			let res = await api.online.checkIntegrity(token)
			if (res.code === 1000) {
				commit('changeCvValid', res.data)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 获取在线简历信息
	getOnlineCvBasic: async function ({ commit }, token) {
		try {
			let res = await api.online.getCvBasicInfo(token)
			if (res.code === 1000) {
				commit('changeOnlineCvBasic', res.data)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 获取在线简历数据
	getOnlineCvData: async function ({ commit }, token) {
		if(!token){
			return
		}
		try {
			let res = await api.online.getOnlineCv(token)
			if (res.code === 1000) {
				commit('changeOnlineCvData', res.data.resume)
			} else if (res.code === 80139) {
				commit('changeOnlineCvData', res.data)
			}
			return res.code
		} catch (e) {
			console.log(e)
		}
	},
	// 获取在线简历状态
	getVisibility: async function ({ commit }, token) {
		try {
			let res = await api.online.getVisibility(token)
			if (res.code === 1000) {
				commit('changeOnlineVisibility', res.data && res.data.cv_invisibile)
			}
		} catch (e) {
			console.log(e)
		}
	},
	// 更新模块
	updateFirstCvInfo: async function ({ commit, state }, cv_account_token) {
		try {
			let res = await api.cv.getIsFirstCv({cv_account_token})
			if(res.code === 1000 && res.data.is_first){
				commit('setIsFirstCvInfo', {
					isFirst: true,
					data: res.data.temp_match
				})
			}else {
				commit('setIsFirstCvInfo', {
					isFirst: false,
					data: res.data.temp_match
				})
			}
		} catch (e) {
			console.log(e)
		}
	},
	getShowNpsState: async function({ commit, state} ,value){
		try{
			let _t = Cookies.get('_t') || Cookies.get('_t_plugin')
			let cvAccountToken = ''
			if (_t) {
				let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
				cvAccountToken = tokenPayload.User.c_t
			}
			let res = await api.nps.isShowNps(cvAccountToken, { channel: (navigator.userAgent.includes('MicroMessenger') && navigator.userAgent.includes('miniProgram')) ? 3 : (navigator.userAgent.includes('wondercv_ios') || this.$route.query.client === 'ios') ? 2 : 4 })
			if(res.code === 1000 ){
				commit('setNpsFlag',res.data.is_fill)
			}
		}catch (e) {

		}
	}
}

const mutations = {
  setCvIntentionData (state, val) {
    state.cvIntentionData = val
  },
	// 设置默认模块标题
	setCvSectionTitle (state, val) {
		state.section_titles = val
	},
	// 简历的详情
	changeCvDetail (state, cv) {
		state.cv = cv
	},
	// 是否有profile
	changeProfileState (state, val) {
		state.hasProfile = val
	},
	// 简历的排序
	changeCvSort (state, cvSort) {
		state.cvSort = cvSort
	},
	// 除模板外的所有模块
	changeOverageModule (state, overageModule) {
		state.overageModule = overageModule
	},
	// 简历分数
	changeSuggest (state, data) {
		state.score = data.score
		state.suggestions = data.suggestions
		state.suggestTime = data.updated_at
	},
	// 修改建议的数据
	changeSuggestInfo (state, info) {
		state.suggestInfo = info
	},
	// 当前编辑模块的title
	changeInfoTitle (state, title) {
		state.currentInfoTitle = title
	},
	// 改变基本信息
	changeProfileData (state, profiles) {
		state.profiles = profiles
	},
	// 改变当前编辑的经历
	changeCurrentInfo (state, info) {
		state.currentInfo = info
	},
	// 自动排序后替换每个模块的info
	changeModuleInfoBySort (state, { moduleName, infos }) {
		state[moduleName] = infos
	},
	// 改变模块的内容
	changeModuleInfo (state, { moduleName, info }) {
		if (moduleName === 'custom') {
			if (info.length) {
				let id = info[0].custom_section_id
				state[id] = info
			}
		} else {
			state[moduleName] = info
		}
	},
	// 改变其他的信息
	changeExtra (state, extra) {
		state.extra = extra
	},
	// 整理后的简历数据
	changeModuleData (state, data) {
		state.moduleData = data
	},
	// 小贴士，案例，动词
	changeAssistInfo (state, { type, info }) {
		if (type === 'examples') {
			state.examples = info.examples || state.examples
			state.example_tags = info.example_tags || state.example_tags
			state.example_options = info.example_options || state.example_options
		} else {
			state[type] = info[type]
		}
	},
	// 在线简历信息的校验
	changeCvValid (state, valid) {
		state.onlineCvValid = valid
	},
	// 改变在线简历的basic
	changeOnlineCvBasic (state, basic) {
		state.onlineCvBasic = basic
	},
	// 在线简历的数据
	changeOnlineCvData (state, data) {
		state.onlineCvData = data
	},
	// 在线简历的私密度
	changeOnlineVisibility (state, visibility) {
		state.onlineVisibility = visibility
	},
	// 刷新editor
	changeRefreshEditor (state, refresh) {
		state.refreshEditor = refresh
	},
	setSyncData (state, value) {
		state.syncSuccess = value
	},
	setIsFirstCvInfo(state, value){
		state.isFirstCvInfo = value
	},
	setNpsFlag(state, value){
		state.npsFlag = value
	},
	setIsSubItemInfoIds(state, value){
		state.isSubItemInfoIds = value
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
